import gql from 'graphql-tag'

const GET_ALL = gql `
  query getKategoriSurat($perPage: Int!, $page: Int){
    kategoriSurat(first: $perPage, page: $page){
      data{
        id
        nama
        status
      }
    }
  }
`;

export {
  GET_ALL
}